import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withRouter } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import DefaultSettings from '../components/settings';
import { getEnvVariable } from '../../../modules/environmentalList';
import { Button } from '@material-ui/core';
import ArrowLeftOutlined from '@material-ui/icons/ArrowLeftOutlined';
import ArrowRightOutlined from '@material-ui/icons/ArrowRightOutlined';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        "& .MuiCollapse-wrapperInner": {
            marginBottom: '0.5rem',
        },
        marginTop: 3
    },
    heading: {
        fontSize: theme.typography.pxToRem(16),
        flexBasis: '63.33%',
        flexShrink: 0,
        fontWeight: 400
    },
    error: {
        fontSize: theme.typography.pxToRem(16),
        flexBasis: '33.33%',
        flexShrink: 0,
        color: '#fafafa',
        fontWeight: 400
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    highlighted: {
        color: '#673ab7', // Highlight color
        fontWeight: 'bold'
    },
    button: {
        margin: theme.spacing(1),
        padding: theme.spacing(1),
        borderRadius: '5px',
        // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    },
    primaryButton: {
        backgroundColor: 'rgba(0, 0, 255, 0.1)',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 255, 0.2)',
        },
    },
    nextButton: {
        color: '#33691e',
        backgroundColor: '#dcedc8',
        '&:hover': {
            backgroundColor: '#aed581',
        },
    }
}));

function Accordions(props) {
    const { steps, view, sections, SectionContext, sectionKeysData, errorSections, hideSections } = props;
    const [expanded, setExpanded] = useState(getEnvVariable('AccessPortal') === 'E' ? [2] : [0])
    const classes = useStyles();
    const SectionName = getEnvVariable('ModuleKey') == 'WRS' ? `Summary Section` : `Permit Application Status`;
    const sectionRefs = useRef([]);


    const scrollToSection = (index) => {
        setTimeout(() => {
            const sectionElement = sectionRefs.current[index];
            if (sectionElement) {
                sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });

                // Fallback for browsers that don't support smooth scrolling
                window.scrollTo({
                    top: sectionElement.offsetTop - 100, // Adjust offset as needed
                    behavior: "smooth"
                });
            }
        }, 200); // Slight delay to allow state update
    };


    const handleNext = (index) => {
        let nextIndex = index + 1;
        while (nextIndex < steps.length && hideSections.includes(steps[nextIndex])) {
            nextIndex++;
        }

        setExpanded([nextIndex]);

        // Ensure scrolling happens after the state is updated
        setTimeout(() => scrollToSection(nextIndex), 300);
    };

    const handlePrevious = (index) => {
        let prevIndex = index - 1;
        while (prevIndex >= 0 && hideSections.includes(steps[prevIndex])) {
            prevIndex--;
        }

        setExpanded([prevIndex]);

        // Ensure scrolling happens after the state is updated
        setTimeout(() => scrollToSection(prevIndex), 300);
    };


    useEffect(() => {
        if (expanded.length > 0) {
            const lastExpandedIndex = expanded[expanded.length - 1];
            scrollToSection(lastExpandedIndex);
        }
    }, [expanded]);

    useEffect(() => {
        console.log("Expanded Section:", expanded);
        console.log("Section Ref:", sectionRefs.current);
    }, [expanded]);



    return (
        <div className={classes.root}>
            {sections.map((section, index) => {
                if (hideSections.includes(steps[index])) {
                    return null
                }
                return <Accordion key={index} className={steps[index] + ' applicaiton-border-radius my-2'}
                    defaultExpanded={section.length > 0 && sectionKeysData &&
                        sectionKeysData[section[0].props.SectionKey] === true}
                    elevation={expanded.includes(index) ? 10 : 0}
                    style={{
                        borderRadius: '10px',
                        marginLeft: 3,
                        marginRight: 3,
                        marginBottom: 0,
                        marginTop: 0,
                        padding: 0,
                        boxShadow: expanded.includes(index) ? '0 0 5px #673ab7' : 'none',
                    }}
                    expanded={expanded.includes(index) ? true : false}
                    onChange={(event, isExpanded) => {
                        if (isExpanded) {
                            setExpanded([...expanded, index]);
                            scrollToSection(index);
                        } else {
                            setExpanded(expanded.filter(item => item !== index));
                        }
                    }}
                    ref={(el) => {
                        if (el) sectionRefs.current[index] = el;
                    }}

                >
                    <AccordionSummary
                        style={{
                            backgroundColor: errorSections[steps[index]] === true ? '#f44336' : '',
                            flexDirection: 'row-reverse',
                            maxHeight: '45px', minHeight: '45px',
                            borderRadius: '10px',
                            padding: '0px',
                        }}
                        expandIcon={<ExpandMoreIcon />}
                        IconButtonProps={{
                            disableRipple: true
                        }}
                    >
                        <Typography className={`${errorSections[steps[index]] === true ? classes.error : classes.heading} ${expanded.includes(index) ? classes.highlighted : ''}`}>
                            {steps[index] === 'Header' ? `Permit Application Status` : steps[index]} &nbsp;
                            {SectionContext && steps[index] && SectionContext[steps[index]] &&
                                <Tooltip title={SectionContext[steps[index]] ? SectionContext[steps[index]].SectionDescription : null} placement="bottom-start" >
                                    <HelpOutlineIcon fontSize="small" style={{ width: '0.6em', paddingBottom: 5, color: getEnvVariable('ModuleKey') === 'AEPS' ? "#00355f" : '#007bff' }}
                                        onClick={() => DefaultSettings.showDrawer(SectionContext[steps[index]].SectionContextHelp)} />
                                </Tooltip>}
                        </Typography>
                    </AccordionSummary>
                    <div className="col-sm-12 ">
                        {section.map((eachsec, idx) => {
                            return <AccordionDetails key={idx} className={eachsec.props.className} >
                                <div className="col-sm-11 mx-3">{eachsec}</div>
                            </AccordionDetails>
                        })}
                        <div className="col-sm-12 p-1 d-flex justify-content-center">
                            {index > 0 && (
                                <Tooltip title="Go to the previous section" placement="top">
                                    <Button size='small' variant='outlined' color='primary' onClick={() => handlePrevious(index)} disabled={index === 0} className={`${classes.button} ${classes.primaryButton}`}>
                                        <Typography style={{ fontSize: 12, fontWeight: 'bold' }}><ArrowLeftOutlined />Previous {index > 0 && `(${steps[index - 1] === 'Map' ? steps[index - 2] : steps[index - 1] === 'Header' ? 'Permit Application Status' : steps[index - 1]})`}</Typography>
                                    </Button>
                                </Tooltip>
                            )}
                            {index < sections.length - 1 && <Tooltip title="Go to the next section" placement="top">
                                <Button variant='outlined' size='small' onClick={() => handleNext(index)} className={`${classes.button} ${classes.nextButton}`} style={{ marginLeft: index > 0 ? '10px' : '0' }}>
                                    <Typography style={{ fontSize: 12, fontWeight: 'bold' }}>Next {index < sections.length - 1 && `(${steps[index + 1] === 'Map' ? steps[index + 2] : steps[index + 1] === 'Header' ? 'Permit Application Status' : steps[index + 1]})`}<ArrowRightOutlined /></Typography>
                                </Button>
                            </Tooltip>}
                        </div>
                    </div>
                </Accordion>
            })}
        </div>
    );
}

export default withRouter(Accordions);